import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { delay, map, of, startWith } from 'rxjs';
import { StudentFeedbackService } from '../student-feedback.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastmessageService } from 'src/app/toastmessage.service';
import { ActivatedRoute } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-student-feedback-dialog',
  templateUrl: './student-feedback-dialog.component.html',
  styleUrls: ['./student-feedback-dialog.component.scss']
})
export class StudentFeedbackDialogComponent {
  counsellingReport!: any
  // Academicyearlist: any[] = [];
  AcademicOptions: any;
  statelist: any;
  stateOptions: any;
  cityOptions: any;
  citylist: any;
  campuslist: any;
  campusOptions: any;
  stateId: any;
  cityId: any;
  counserlerlist: any;
  counserlistOptions: any;
  Reasonslist: any;
  // issueslist: any;
  issueslist: any;
  ReasonsOptions: any;
  IdentifiedOptions: any;
  reasonId: any;
  campusid: any;
  createby: any;
  allReasonCategoryData: any[];
  data1: string;
  startDate: any;
  endDate: any;
  start: FormControl<Date | null> = new FormControl<Date | null>(null); // Initialize with null
  end: FormControl<Date | null> = new FormControl<Date | null>(null);
  today: Date = new Date();
  minFromDate: Date | null = null;
  maxFromDate: Date | null = this.today;
  minToDate: Date | null = null;
  maxToDate: Date | null = this.today;
  lastSelectedLabel = '';
  empId: any;
  Academicyearlist = [
    { year: 'STUDENT WELL BEING' },
    { year: 'ADAPTABILITY QUESTIONNAIRE' }
  ];
  constructor(private verification: StudentFeedbackService, private spinner: NgxSpinnerService, private fb: FormBuilder, private toast: ToastmessageService, private route: ActivatedRoute, private dialog: MatDialog, private dialogRef: MatDialogRef<StudentFeedbackDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,) { }
  ngOnInit(): void {
    // this.adapter.setLocale('en-GB');
    this.counsellingReport = new FormGroup({
      StateControl: new FormControl('', Validators.required),
      StateControl2: new FormControl('', Validators.required),
      categoryName : new FormControl('', Validators.required),
      Academic12: new FormControl('', Validators.required),
      CampusControl: new FormControl('', Validators.required),
      CampusControl2: new FormControl('', Validators.required),
      cityControl: new FormControl('', Validators.required),
      cityControl12: new FormControl('', Validators.required),
      campusControl: new FormControl('', Validators.required),
      campusControl12: new FormControl('', Validators.required),
      selectedDate: new FormControl('', Validators.required),
      CounsellerControl: new FormControl('', Validators.required),
      CounsellerControl12: new FormControl('', Validators.required),
      ReasonsControl: new FormControl('', Validators.required),
      ReasonsControl2: new FormControl('', Validators.required),
      IdentifiedControl: new FormControl('', Validators.required),
      IdentifiedControl2: new FormControl('', Validators.required),
      start: new FormControl<Date | null>(null),
      end: new FormControl<Date | null>(null)


    });
    this.AcademicOptions = this.counsellingReport.get('Academic12')?.valueChanges.pipe(
      startWith(''),
      map((value: any) => this.Filter(value, this.Academicyearlist, 'year'))
    );
    
    if (this.data) {
      this.getstates(); // always call this

      if (this.data.stateId) {
        this.getcity(this.data.stateId);
      }

      if (this.data.cityId) {
        this.getCampus(this.data.cityId);
        this.getconseller(this.data.campusId);
      }
      this.counsellingReport.patchValue({
        categoryName : this.data.categoryName  || null,
        StateControl: this.data.stateId || null,
        cityControl: this.data.cityId || null,
        campusControl: this.data.campusId || null,
        CounsellerControl: this.data.createdBy || null,
        start: this.data.fromDate ? new Date(this.data.fromDate) : null,
        end: this.data.toDate ? new Date(this.data.toDate) : null
      });
    }
  }
  private parseDdMmmYyyy(value: string | null | undefined): Date | null {
    if (!value) return null;

    const [dayStr, monStr, yearStr] = value.split('-');
    if (!dayStr || !monStr || !yearStr) return null;

    const months: { [key: string]: number } = {
      Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
      Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11,
    };

    const monthIndex = months[monStr];
    if (monthIndex === undefined) return null;

    const day = Number(dayStr);
    const year = Number(yearStr);

    return new Date(year, monthIndex, day);
  }
  getAcademicyear() {
    // this.verification.getacademic().subscribe((res: any) => {
    //   this.Academicyearlist = (res as string[]).map((year: string) => ({ year: year }))
    //   this.AcademicOptions = this.counsellingReport.get('Academic12').valueChanges.pipe(
    //     startWith(''),
    //     map((value: any) => this.Filter(value, this.Academicyearlist, 'year'))
    //   );
    // })
  }
  onAcademicYearChange(selectedYear: string) {
    console.log("Selected year:", selectedYear);
    this.getstates();
  }
  // private Filter(value: string, list: any[], name: string): any[] {
  //   const searchValue = value?.trim().toLocaleLowerCase() ?? '';

  //   return list.filter((item: any) => {
  //     console.log('Checking:', item[name]);
  //     const target = item[name]?.toString().trim().toLocaleLowerCase() ?? '';
  //     return target.includes(searchValue);
  //   });
  // }

  private Filter(value: string, list: any[], name: string): any[] {
    const searchValue = value.trim().toLocaleLowerCase();
    let filteredList = list.filter((item: any) => item[name] && item[name].trim().toLocaleLowerCase().includes(searchValue));
    return filteredList;
  }
  getCampus1(e: any) {

  }

  getCampus(e: any) {
    this.cityId = typeof e === 'object' ? e.cityId : e;
    if (typeof e === 'object' && e.cityName) {
      this.lastSelectedLabel = `City: ${e.cityName}`;
    }
    this.verification.getcampus(this.cityId).subscribe((res: any) => {
      this.campuslist = res
      this.campusOptions = this.counsellingReport.get('CampusControl2').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.campuslist, 'campusName'))
      );
      this.getconseller(e);
      this.checkAndFetchReasons()
    })
  }
  formatDate(date: Date | null): string {
   if (!date) return '';

 const d = new Date(date);

  const year = d.getFullYear();
  const month = ('0' + (d.getMonth() + 1)).slice(-2);
  const day = ('0' + d.getDate()).slice(-2);

  return `${year}-${month}-${day}`;

  }
  getReport() {
    const form = this.counsellingReport.value;
     if (!form.categoryName ) {
       alert('Please select categoryName ');
      return;
     }
    if (this.start.value && !this.end.value) {
      alert('Please select End Date because Start Date is selected.');
      return;
    }


    const paramsObj: any = {
      categoryName : form.categoryName ,
      stateId: this.stateId,
      cityId: this.cityId,
      campusId: form.campusControl || '',
      createdBy: form.CounsellerControl || '',
      fromDate: this.formatDate(this.start.value),
      toDate: this.formatDate(this.end.value),
      lastSelectedLabel: this.lastSelectedLabel

    };
    this.dialogRef.close({ params: paramsObj });
    // const formValues = this.counsellingReport.value;
    // const paramsObj: any = {
    //   academicYear: formValues.Academic,               
    //   stateId: formValues.StateControl,             
    //   cityId: formValues.cityControl,                  
    //   campusId: formValues.campusControl || '',        
    //   createdBy: formValues.CounsellerControl || '', 
    //   counselCatId: formValues.ReasonsControl || '',
    //   counselCategoryReasonIds: formValues.IdentifiedControl || '',       
    //   selectedDate: formValues.selectedDate || ''       
    // };
    // this.dialogRef.close({ params: paramsObj });
  }
  getcounsellername(e: any) {
    this.empId = typeof e === 'object' ? e.empId : e;
    if (typeof e === 'object' && e.empName) {
      this.lastSelectedLabel = `Counseller: ${e.empName}`;
    }

  }
  getconseller(e: any) {
    let cityId = this.cityId;
    let campusId: any = null;
    if (typeof e === 'object' && e?.campusId) {
      campusId = e.campusId;
      this.lastSelectedLabel = `Campus: ${e.campusName}`;
    }


    if (typeof e === 'object' && e?.cityId) {
      cityId = e.cityId;
      campusId = null; 
    }
    if (!cityId) return;

  }
  getcity(e: any) {
    this.stateId = typeof e === 'object' ? e.stateId : e;
    this.verification.getcity(this.stateId).subscribe((res: any) => {
      this.citylist = res
      this.cityOptions = this.counsellingReport.get('cityControl12').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.citylist, 'cityName'))
      );
      this.checkAndFetchReasons()
    })
  }
  getstates() {
    this.verification.getstate().subscribe((res: any) => {
      this.statelist = res
      this.stateOptions = this.counsellingReport.get('StateControl2').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.statelist, 'stateName'))
      );
    })
  }
  checkAndFetchReasons() {
    const academicYear = this.counsellingReport.get('Academic')?.value;
    const cityId = this.cityId;
    const campusId = this.campusid;
    const counsellorId = this.createby;
  }
 
  checkFieldsIndividually() {
    const form = this.counsellingReport.value;
    if (!form.Academic) {
      alert('Please select Academic Year');
      return;
    } else if (!form.StateControl) {
      alert('Please select State');
      return;
    } else if (!form.cityControl) {
      alert('Please select City');
      return;
    }
  }

  clearCity() {
    this.counsellingReport.get('cityControl')?.reset();
    this.cityOptions = of([]).pipe(delay(0));
    this.citylist = '';
    this.clearCampus();
  }

  clearCampus() {
    this.counsellingReport.get('campusControl')?.reset();
    this.campusOptions = of([]).pipe(delay(0));
    this.campuslist = '';
    this.clearCounsler();
  }

  clearCounsler() {
    this.counsellingReport.get('CounsellerControl')?.reset();
    this.counserlistOptions = of([]).pipe(delay(0));
    this.counserlerlist = '';
    this.clearReason();
  }

  clearReason() {
    this.counsellingReport.get('ReasonsControl')?.reset();
    this.ReasonsOptions = of([]).pipe(delay(0));
    this.Reasonslist = '';
    this.clearIdentification();
  }

  clearIdentification() {
    this.counsellingReport.get('IdentifiedControl')?.reset();
    this.issueslist = [];
  }

  handleDateChange(type: 'start' | 'end', event: any) {
    if (type === 'start') {

      console.log(`Start Date: ${event.value}`);
      this.minToDate = event.value;
      this.data1 = "betweendates";

      if (event.value !== null) {
        const selectedStartDate = new Date(event.value);
        const maxDateLimit = new Date(selectedStartDate.getFullYear(), selectedStartDate.getMonth(), selectedStartDate.getDate() + 30);
        this.maxToDate = maxDateLimit > this.today ? this.today : maxDateLimit;
        // if (this.end.value) {
        //   this.end.setValue(null);
        // }
        if (this.start.value !== event.value) {
          this.start.setValue(event.value);
        }
      }
    } else if (type === 'end') {

      console.log(`End Date: ${event.value}`);
      this.maxFromDate = event.value;
      this.data1 = "betweendates";

      if (event.value !== null) {
        const selectedEndDate = new Date(event.value);
        const minDateLimit = new Date(selectedEndDate.getFullYear(), selectedEndDate.getMonth(), selectedEndDate.getDate() - 30);
        this.minFromDate = minDateLimit;
        if (this.end.value !== event.value) {
          this.end.setValue(event.value);
        }
      }
    }
    // this.clearRadioButtons();
  }

}
